import { createFeatureSelector, createSelector } from '@ngrx/store';

import { MsalAuthSelectors } from 'src/app/features/msal-auth/store/selectors';

import { SessionHandoffState } from '../state';

export const getSessionHandoffState = createFeatureSelector<SessionHandoffState.State>('sessionHandoff');

export const getAssociatedUsers = createSelector(
  getSessionHandoffState,
  (state: SessionHandoffState.State) => state.associatedUsers
);

/**
 * True when B2C has already established this participant's identity - a `Verified` role plus a
 * token issued for this specific participant. Set during check-in, so a participant returning
 * from ESign does not need to prove who they are a second time.
 *
 * The GUID match matters: without it a verified token would vouch for anyone on the device.
 */
export const selectIsVerifiedParticipant = (packageUserGuid: string) =>
  createSelector(
    MsalAuthSelectors.getIsUserVerified,
    MsalAuthSelectors.getUserGuid,
    (isUserVerified, authenticatedUserGuid) =>
      isUserVerified &&
      !!authenticatedUserGuid &&
      authenticatedUserGuid.toLowerCase() === packageUserGuid?.toLowerCase()
  );
